import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatCardModule } from '@angular/material/card';
import { NavComponent } from '../../components/nav.component/nav.component';
import { FooterComponent } from '../../components/footer.component/footer.component';

/**
 * Phase 7: real download page (replaces the generated `<p>works!</p>` stub).
 *
 * Configurable via env-loaded properties on the component. Until App Store
 * / Play Store links are live, the buttons fall through to a "coming soon"
 * panel — better than dangling broken links.
 */

@Component({
  selector: 'app-download',
  standalone: true,
  imports: [
    CommonModule,
    RouterLink,
    MatButtonModule,
    MatIconModule,
    MatCardModule,
    NavComponent,
    FooterComponent,
  ],
  templateUrl: './download.component.html',
  styleUrl: './download.component.scss',
})
export class DownloadComponent {
  // When set, the buttons will direct users to these URLs. Otherwise they
  // surface a "coming soon" message.
  appStoreUrl: string | null = null; // e.g. 'https://apps.apple.com/app/idXXXXXXXX'
  playStoreUrl: string | null = null; // e.g. 'https://play.google.com/store/apps/details?id=com.jccdevelopment.skiptomyloo'
  testflightUrl: string | null = null; // optional invite link while iOS is in beta

  get hasAnyLink(): boolean {
    return !!(this.appStoreUrl || this.playStoreUrl || this.testflightUrl);
  }

  open(url: string | null): void {
    if (!url) return;
    window.open(url, '_blank', 'noopener,noreferrer');
  }
}
